import { render, staticRenderFns } from "./SupervisionForm.vue?vue&type=template&id=0a5570d8&scoped=true"
import script from "./SupervisionForm.vue?vue&type=script&lang=js"
export * from "./SupervisionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5570d8",
  null
  
)

export default component.exports